import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { DatePickerModel } from '../components/date-picker-dialog/date-picker.model';
import { HeaderService } from '../components/header/header.service';
import { AgGridRequestService } from './ag-grid-request.service';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class ReportsService  implements OnDestroy{
  account;
  isInActive: any[] = [];
  sortOptions$= new BehaviorSubject<any>(null);
  sortingModel;
  currentDateFilter;
  selectedFilter:any;
  private destroy$ = new Subject<void>();

  constructor(
    private headerService: HeaderService,
    private agGridRequestService: AgGridRequestService,
    private http: HttpClient
  ) {
    this.headerService.accountsSelected.pipe(takeUntil(this.destroy$)).subscribe((e) => (this.account = e[0]));
  }

  private headers = new HttpHeaders({ "Content-Type": "application/json" });
  options = { headers: this.headers };
  private url = "api/reports";

  BySku(datefrom,dateto,body, columnDefs, globalSearch?: string,sumColumns?) {
    const payload =  this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch,
      null,
      sumColumns
    );
    payload.dateFrom=datefrom;
    payload.dateTo=dateto;
    return this.http.post(`/${this.url}/BySku`, payload, this.options);
  }

  ByDate(
    datefrom,
    dateto,
    body,
    columnDefs,
    globalSearch?: string,
    setAccount?,
    sumColumns?
  ) {
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch,
      setAccount,
      sumColumns
    );
    payload.dateFrom=datefrom;
    payload.dateTo=dateto;
    return this.http.post(`/${this.url}/ByDate`, payload, this.options);
  }

  private ConstructAnalyticsGridPayload(
    body,
    columnDefs,
    date: DatePickerModel,
    globalSearch?: string
  ) {
    let filters = {};
    if (this.account) {
      filters["Account"] = {
        filterType: "set",
        values: [this.account],
      };
    }

    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch,
      filters
    );
    if (date) {
      (payload.dateFrom = new Date(
        new Date(date.from).setHours(0, 0, 0, 0) -
          date.from.getTimezoneOffset() * 60000
      ).toISOString()),
        (payload.dateTo = new Date(
          new Date(date.to).setHours(23, 59, 59, 59) -
            date.to.getTimezoneOffset() * 60000
        ).toISOString());
    }
    return payload;
  }

  private ConstructAnalyticsGridPayloadByDate(
    body,
    columnDefs,
    date: DatePickerModel,
    globalSearch?: string,
    setAccount?,
    sumColumns?
  ) {
    let filters = {};
    if (this.account && !setAccount) {
      filters["Account"] = {
        filterType: "set",
        values: [this.account],
      };
    }
    if (date) {
      filters["Date"] = {
        filterType: "date",
        type: "inRange",
        dateFrom: new Date(
          new Date(date.from).setHours(0, 0, 0, 0) -
            date.from.getTimezoneOffset() * 60000
        ).toISOString(),
        dateTo: new Date(
          new Date(date.to).setHours(23, 59, 59, 59)
        ).toISOString(),
      };
    }

    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch,
      filters,
      sumColumns
    );

    return payload;
  }

  
  bySkuExport(body, columns, globalSearch,isExport) {
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columns,
      globalSearch,
      null,
      null,
      isExport
    );

    return this.http.post(`/${this.url}/BySkuExport`, payload, {
      headers: this.headers,
      observe: "response",
      responseType: "blob",
    });
  }

  byDateExport(filters, columns, globalSearch,isExport?){   
    const body = {
      filterModel: filters,
    };
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columns,
      globalSearch,
      null,
      null,
      isExport
    );

    return this.http.post(`/${this.url}/ByDateExport`, payload, {
      headers: this.headers,
      observe: "response",
      responseType: "blob",
    });
  }

  GridByAmazonSummaryExport(body, columns, globalSearch,isExport) {
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columns,
      globalSearch,
      null,
      null,
      isExport
    );
    payload.loadAll= true;
    return this.http.post(`/${this.url}/GridByAmazonSummaryExport`, payload, {
      headers: this.headers,
      observe: "response",
      responseType: "blob",
    });
  }

  kpiDashboardDetails(payload) {
    return this.http.post(`/${this.url}/KpiDashboard`, payload, this.options);
  }

  KpiPerDay(payload) {
    return this.http.post(`/${this.url}/KpiPerDay`, payload, this.options);
  }

  ByProduct(
    datefrom,
    dateto,
    body,
    columnDefs,
    globalSearch?: string,
    groupBy? : any,
    sortModel?,
    isGrid = true,
    filterModel?,
    sumColumns?
  ) {
    let payload: any = {};
    if(isGrid){
       payload =  this.agGridRequestService.transformAgGridRequest(
        body,
        columnDefs,
        globalSearch,
        null,
        sumColumns
      );
    }else{
      payload.columns=columnDefs;
      payload.sumColumns = this.agGridRequestService.getColumns(sumColumns);
      payload.endRow= 5,
      payload.filterModel= {},
      payload.groupKeys= [],
      payload.pivotCols= [],
      payload.pivotMode= false,
      payload.rowGroupCols= [],
      payload.sortModel= [],
      payload.startRow= 0,
      payload.valueCols= []
    }    
    if(filterModel) payload.filterModel = filterModel;
    payload.dateFrom=datefrom;
    payload.dateTo=dateto;
    payload.groupBy= groupBy;
     if(sortModel) payload.sortModel= sortModel;
    return this.http.post(`/${this.url}/ByProduct`, payload, this.options);
  }

  ByProductExport(body, columns, globalSearch,groupBy,isExport) {
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columns,
      globalSearch,
      null,
      null,
      isExport
    );
    payload.groupBy= groupBy;
    payload.loadAll= true;

    return this.http.post(`/${this.url}/ByProductExport`, payload, {
      headers: this.headers,
      observe: "response",
      responseType: "blob",
    });
  }

  ByProducts(payload) {
    return this.http.post(`/${this.url}/ByProduct`, payload, this.options);
  }

  GetSalesOrderList(body, columnDefs, globalSearch?,sumColumns?) {
    if(body?.sortModel?.length == 0){
      body.sortModel = [
        {
          colId: 'OrderDate',
          sort: 'desc'
        }
      ]
    }
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch,
      null,
      sumColumns
    );
    return this.http.post(
      `/${this.url}/OrderList`,
      payload,
      this.options
    );
  }

  ByVendor(datefrom,dateto,body, columnDefs, globalSearch?) {
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch,
    );
    payload.dateFrom=datefrom;
    payload.dateTo=dateto;
    return this.http.post(
      `/${this.url}/ByVendor`,
      payload,
      this.options
    );
  }
  byVendorExport(body, columns, globalSearch) {
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columns,
      globalSearch
    );
    payload.loadAll= true;
    return this.http.post(`/${this.url}/ByVendorExport`, payload, {
      headers: this.headers,
      observe: "response",
      responseType: "blob",
    });
  }

  GridByVendorSummary(dateFrom,dateTo) {
    return this.http.get(
      `/${this.url}/GridByVendorSummary?DateFrom=${dateFrom}&DateTo=${dateTo}`,
      this.options
    );
  }
  
  gridByItemInventory(body, columnDefs, globalSearch?,sumColumnDefs?){
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch,
      null,
      sumColumnDefs
    );
      payload.month = this.selectedFilter?.month ? this.selectedFilter.month : (new Date().getMonth());
      payload.year = this.selectedFilter?.year ? this.selectedFilter.year : new Date().getFullYear();
    return this.http.post(
      `/${this.url}/GridByItemInventory`,
      payload,
      this.options
    );
  }

  gridByItemInventoryExport(body, columns, globalSearch) {
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columns,
      globalSearch
    );
    payload.month = this.selectedFilter?.month ? this.selectedFilter.month : (new Date().getMonth() + 1);
    payload.year = this.selectedFilter?.year ? this.selectedFilter.year : new Date().getFullYear();
    payload.loadAll= true;
    return this.http.post(`/${this.url}/GridByItemInventoryExport`, payload, {
      headers: this.headers,
      observe: "response",
      responseType: "blob",
    });
  }
  
  GetSalesTrends(body,columnDefs,globalSearch?,currentDate?,sumColumns?) {
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch,
      null,
      sumColumns
    );
    if(currentDate){
      currentDate.forEach((ele,i)=>{
        const keys=Object.keys(ele);
        keys?.forEach(key=>{
          payload[key]=currentDate[i][key];
        })
      })
    }
    return this.http.post(`/${this.url}/Trends`,payload, this.options)
  }

  GetSalesTrendsExport(filters, columns, globalSearch) {
    const body = {
      filterModel: filters,
    };
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columns,
      globalSearch
    );
    payload.loadAll= true;
    return this.http.post(`/${this.url}/TrendsBySkuExport`, payload, {
      headers: this.headers,
      observe: "response",
      responseType: "blob",
    });
  }

  getPLReportByMonth(payload) {
    return this.http.get(
      `/${this.url}/GetPLReportByMonth?StartRow=${payload.startRow}&EndRow=${
        payload.endRow
      }${payload?.dateFrom ? "&DateFrom=" + payload.dateFrom : ""}${
        payload?.dateTo ? "&DateTo=" + payload.dateTo : ""
      }
      ${payload.globalSearch ? "&GlobalSearch=" + payload.globalSearch : ""}${
        payload.groupName != null ? "&GroupName=" + payload.groupName : ""
      }${payload.itemName != null ? "&ItemName=" + payload.itemName : ""}`,
      this.options
    );
  }

  getPLReportByYear(payload) {
    return this.http.get(
      `/${this.url}/GetPLReportByYear?StartRow=${payload.startRow}&EndRow=${
        payload.endRow
      }${payload?.dateFrom ? "&DateFrom=" + payload.dateFrom : ""}${
        payload?.dateTo ? "&DateTo=" + payload.dateTo : ""
      }
      ${payload.globalSearch ? "&GlobalSearch=" + payload.globalSearch : ""}
      ${payload.groupName != null ? "&GroupName=" + payload.groupName : ""}${
        payload.itemName != null ? "&ItemName=" + payload.itemName : ""
      }`,
      this.options
    );
  }

  getPLReportByWeek(payload) {
    return this.http.get(
      `/${this.url}/GetPLReportByWeek?StartRow=${payload.startRow}&EndRow=${
        payload.endRow
      }${payload?.dateFrom ? "&DateFrom=" + payload.dateFrom : ""}${
        payload?.dateTo ? "&DateTo=" + payload.dateTo : ""
      }
      ${payload.globalSearch ? "&GlobalSearch=" + payload.globalSearch : ""}
      ${payload.groupName != null ? "&GroupName=" + payload.groupName : ""}${
        payload.itemName != null ? "&ItemName=" + payload.itemName : ""
      }`,
      this.options
    );
  }
  
  getPLReportByQuarter(payload) {
    return this.http.get(
      `/${this.url}/GetPLReportByQuarter?StartRow=${payload.startRow}&EndRow=${
        payload.endRow
      }${payload?.dateFrom ? "&DateFrom=" + payload.dateFrom : ""}${
        payload?.dateTo ? "&DateTo=" + payload.dateTo : ""
      }
      ${payload.globalSearch ? "&GlobalSearch=" + payload.globalSearch : ""}
      ${payload.groupName != null ? "&GroupName=" + payload.groupName : ""}${
        payload.itemName != null ? "&ItemName=" + payload.itemName : ""
      }`,
      this.options
    );
  }

  TrendingItemsList(payload){
    return this.http.post(`/${this.url}/TrendingItemsList`,payload, this.options)
  }

  KpiDashboardBySku(payload){
    return this.http.post(`/${this.url}/KpiDashboardBySku`,payload, this.options)
  }

  getPLReport(payload) {
    return this.http.get(
      `/${this.url}/GetPLReport?StartRow=${payload.startRow}&EndRow=${
        payload.endRow
      }&Type=${payload.type}${payload?.dateFrom ? "&DateFrom=" + payload.dateFrom : ""}${
        payload?.dateTo ? "&DateTo=" + payload.dateTo : ""
      }
      ${payload.globalSearch ? "&GlobalSearch=" + payload.globalSearch : ""}
      ${payload.groupName != null ? "&GroupName=" + payload.groupName : ""}${
        payload.itemName != null ? "&ItemName=" + payload.itemName : ""
      }`,
      this.options
    );
  }
  getPLReportBySettlement(payload) {
    return this.http.get(
      `/${this.url}/GetPLReportBySettlement?StartRow=${payload.startRow}&EndRow=${
        payload.endRow
      }${
        payload.settlement?.length
          ? payload.settlement.map((status) => `&SettlementIds=${status}`).join("")
          : ""
      }${payload?.dateFrom ? "&DateFrom=" + payload.dateFrom : ""}${
        payload?.dateTo ? "&DateTo=" + payload.dateTo : ""
      }
      ${payload.globalSearch ? "&GlobalSearch=" + payload.globalSearch : ""}
      ${payload.groupName != null ? "&GroupName=" + payload.groupName : ""}${
        payload.itemName != null ? "&ItemName=" + payload.itemName : ""
      }`,
      this.options
    );
  }


GridByAmazonSummary(body, columnDefs, globalSearch?,sumColumn?) {
  const filters = {}
  if (this.account) {
    filters['Account'] = {
        filterType: "set",
        values: [this.account],
      };
    }
  const payload = this.agGridRequestService.transformAgGridRequest(
    body,
    columnDefs,
    globalSearch,
    filters,
    sumColumn
  );
  return this.http.post(`/${this.url}/GridByAmazonSummary`, payload, {
    ...this.options,

  });
}

  ProfitComparison(payload){
    return this.http.post(`/${this.url}/ProfitComparison`,payload, this.options)
  }


  KpiProductDashboard(payload){
    return this.http.post(`/${this.url}/KpiProductDashboard`,payload,this.options)
  }

  AnalyticsSectionBreakdown(payload){
    return this.http.post(`/${this.url}/AnalyticsSectionBreakdown`,payload, this.options)
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
